import '@ionic/react/css/core.css'
import React, { useEffect, useState } from "react";

import {
  RetorikAgent,
  //RetorikWidget,
  //characters,
  sendEvent,
  setCurrentSubView,
  AvailableViews,
  AvailableSubViews,
  CurrentSubView
} from "@davi-ai/retorik-framework";
import type {
  AddressData,
  WidgetConfiguration,
  //ChatbotData,
  Configuration,
  MapConfiguration,
  RetorikMenusConfiguration
  //ViewsConfiguration,
  //RetorikThemeColors,
} from "@davi-ai/retorik-framework";
import { tenants, userData } from "./data";
import { MapIcon } from "@davi-ai/retorik-map";

import { FullMenu } from '@davi-ai/retorik-framework-hospitality'
import { setupIonicReact } from '@ionic/react'
setupIonicReact()

const addressData: AddressData = tenants.OTNievre;

const widgetConfig: WidgetConfiguration =
{
  button: {
    text: {
      color: '#fff',
      content: 'BESOIN D\'AIDE'
    },
    image: {
      url: 'images/lea@2x.png',
      height: "3rem",
      marginY: true
    },
    border: {
      color: '#fff'
    },
    background: {
      color: "#0082CA"
    }
  },
  large: {}
}

const hospitalityFullMenu = new FullMenu(sendEvent).menu
const defaultMenusConfig: RetorikMenusConfiguration = {
  baseMenu: [
    { view: AvailableViews.home, indice: 1 },
    {
      // Since framework v5, the interactive map is embedded in the framework
      clickHandler: () => setCurrentSubView(CurrentSubView.map),
      label: {
        "fr-FR": "Carte interactive",
        "en-US": "Interactive map",
      },
      icon: <MapIcon />,
      indice: 2,
    },
    { view: AvailableViews.news, indice: 3 },
    { view: AvailableViews.weather, indice: 4 },
    { view: AvailableViews.emergency, indice: 5 }
  ],
  customMenu: [
    hospitalityFullMenu,
    []
  ],
  subMenu: [
    { view: AvailableSubViews.history, indice: 1 },
    { view: AvailableSubViews.tutorial, indice: 2 }
  ]
};

const defaultConfig: Configuration = {
  position: {
    searchForLocation: true,
  },
  ...defaultMenusConfig
}

// Nevers
const defaultPosition = { latitude: 46.98333, longitude: 3.16667 };

const mapConfig: MapConfiguration = {
  mapCenter: [defaultPosition.latitude, defaultPosition.longitude]
}

// Use the GPS position of the user, or Nevers if it is denied / unavailable
const getUserPosition = (): Promise<{ latitude: number; longitude: number }> =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(defaultPosition);
      return;
    }
    // Fallback if the user doesn't answer the permission prompt
    const fallbackTimer = setTimeout(() => resolve(defaultPosition), 15000);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        clearTimeout(fallbackTimer);
        resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude });
      },
      () => {
        clearTimeout(fallbackTimer);
        resolve(defaultPosition);
      },
      { timeout: 10000 }
    );
  });

const App = () => {
  const [props, setProps] = useState<any>();
  useEffect(() => {
    getUserPosition().then((position) => {
      setProps({
        addressData: addressData,
        userData: userData,
        widgetConfig,
        config: {
          ...defaultConfig,
          position: { ...defaultConfig.position, ...position }
        },
        mapConfig,
      });
    });
  }, [])

  return (props ?
    <RetorikAgent
      {...props} />
    :
    (
      <></>
    )
  );
};

export default App;